import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { UiButton } from './ui';
import { usePermissions } from '../hooks/usePermissions';

const AccessDeniedPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { can } = usePermissions();
  // ถ้าไม่มีสิทธิ์ Dashboard ให้กลับไปหน้า Profile แทน (เข้าได้เสมอ)
  const backPath = can('can_view_dashboard') ? '/' : '/profile';

  return (
    <div className="flex flex-col items-center justify-center h-64 gap-3">
      <FontAwesomeIcon icon={faLock} className="text-4xl text-gray-300 dark:text-slate-600" />
      <p className="text-lg font-semibold text-gray-800 dark:text-slate-100">
        {t('common.noPermission', 'ไม่มีสิทธิ์เข้าถึงหน้านี้')}
      </p>
      <UiButton icon={faArrowLeft} onClick={() => navigate(backPath)}>
        {t('common.backToDashboard', 'กลับหน้าหลัก')}
      </UiButton>
    </div>
  );
};

export default AccessDeniedPage;
